import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/parts/cookie-declaration/index.tsx");
